import "./BloackLoader.modules.css";

const BlockLoader = ({ position = "absolute" }) => {
  return <div className={`block-loader__spinner position-${position}`}></div>;
};

export default BlockLoader;
